import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "./App.css";

import BrowserRouterPage from "./app/router/RouterPage";
import { withAppWrapper } from "./app/hoc/appWrapper";
import { useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { getToken, messaging, onMessage } from "./firebase";
// import { onTokenRefresh } from "firebase/messaging";

function App() {
  const isMobileScreen = useMediaQuery("(min-width:560px)");
  // const [registration, setRegistration] =
  //   useState<ServiceWorkerRegistration | null>(null);
  // const isInitialized = useRef(false); // Prevent duplicate initialization

  // // Register or Reuse Service Worker
  // const registerServiceWorker = async () => {
  //   console.log("Checking for service worker support...");
  //   if ("serviceWorker" in navigator) {
  //     try {
  //       console.log("Waiting for service worker to be ready...");
  //       // Wait for the service worker to be ready (active or installing)
  //       const swRegistration = await navigator.serviceWorker.ready;
  //       console.log("Service worker is ready:", swRegistration);

  //       // If no registration exists, register a new one
  //       if (!swRegistration.active) {
  //         console.log(
  //           "No active service worker found. Registering a new one..."
  //         );

  //         const newRegistration = await navigator.serviceWorker.register(
  //           "/firebase-messaging-sw.js"
  //         );
  //         console.log("Service worker registered:", newRegistration);

  //         await navigator.serviceWorker.ready; // Wait for it to activate
  //         setRegistration(newRegistration);
  //         return newRegistration;
  //       }
  //       console.log("Using existing active service worker:", swRegistration);

  //       // Use the existing active service worker
  //       setRegistration(swRegistration);
  //       return swRegistration;
  //     } catch (err) {
  //       console.error("Service Worker setup failed:", err);
  //       return null;
  //     }
  //   }
  //   console.warn("Service workers are not supported in this browser.");
  //   return null;
  // };

  // // Request Notification Permission
  // const requestNotificationPermission = async () => {
  //   console.log("Requesting notification permission...");

  //   if (Notification.permission !== "granted") {
  //     try {
  //       const permission = await Notification.requestPermission();
  //       console.log("Notification permission status:", permission);

  //       return permission === "granted";
  //     } catch (error) {
  //       console.error("Error requesting notification permission:", error);
  //       return false;
  //     }
  //   }
  //   return true;
  // };

  // // Handle Foreground Messages
  // const handleForegroundMessages = () => {
  //   onMessage(messaging, (payload) => {
  //     console.log("Foreground message received:", payload);
  //     if (payload.data) {
  //       const { title, description, orderID } = payload.data;
  //       alert(
  //         `Title: ${title}\nDescription: ${description}\nOrder ID: ${orderID}`
  //       );
  //     } else {
  //       console.log("No data object in payload:", payload);
  //     }
  //   });
  // };

  // // Get FCM Token
  // const getFCMToken = async (serviceWorkerRegistration: any) => {
  //   console.log("Attempting to retrieve FCM token...");

  //   if (!serviceWorkerRegistration) {
  //     console.error("No active Service Worker provided to getFCMToken.");
  //     return;
  //   }
  //   try {
  //     const currentToken = await getToken(messaging, {
  //       vapidKey:
  //         "BJwMUMuO3hpqUBdqHxYqUCsZAzPDOZPrkylw0hzLFjyqR5TXREPdZpdThBHDhAAbj4K-XVS-O4WrugQuUL3KFsE",
  //       serviceWorkerRegistration,
  //     });
  //     if (currentToken) {
  //       console.log("FCM token retrieved successfully:", currentToken);

  //       localStorage.setItem("FCM_TOKEN", currentToken);
  //     } else {
  //       console.log("No FCM token available.");
  //     }
  //   } catch (err) {
  //     console.error("Error retrieving FCM token:", err);
  //   }
  // };

  // // Initialize Service Worker & Permissions
  // useEffect(() => {
  //   console.log("Initializing service worker...");

  //   if (isInitialized.current) return; // Prevent double execution
  //   isInitialized.current = true;
  //   console.log("Service worker setting up.....");
  //   const initServiceWorker = async () => {
  //     const swRegistration = await registerServiceWorker();
  //     console.log("Service worker registered successfully:", swRegistration);

  //     if (!swRegistration) {
  //       console.error("Service worker setup failed. Aborting.");
  //       return;
  //     }

  //     const permissionGranted = await requestNotificationPermission();
  //     if (permissionGranted) {
  //       await getFCMToken(swRegistration);

  //       // onTokenRefresh(messaging, () => {
  //       //   getToken(messaging, {
  //       //     vapidKey: "BJwMUMuO3hpqUBdqHxYqUCsZAzPDOZPrkylw0hzLFjyqR5TXREPdZpdThBHDhAAbj4K-XVS-O4WrugQuUL3KFsE",
  //       //     serviceWorkerRegistration: swRegistration,
  //       //   })
  //       //     .then((refreshedToken) => {
  //       //       console.log("Token refreshed:", refreshedToken);
  //       //       localStorage.setItem("FCM_TOKEN", refreshedToken);
  //       //     })
  //       //     .catch((err) => console.error("Error refreshing token:", err));
  //       // });
  //     }

  //     handleForegroundMessages();
  //   };

  //   initServiceWorker().catch((err) =>
  //     console.error("Initialization failed:", err)
  //   );
  // }, []);
  //======================
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    const setupNotifications = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          console.log("Notification permission granted.");
          const token = await getToken(messaging, {
            vapidKey:
              "BEqDpIGmWg4ZsmZGM-KpwiotWPDRuHMve2xBJ8yHXJRPJQBcgwDvOgRcFY0PyfHQK67k07blC4EfoUXp9YoiFhY",
          });
          console.log("FCM Token:", token);
          localStorage.setItem("FCM_TOKEN", token);

          // Check service worker status after token generation
          navigator.serviceWorker
            .getRegistration("/firebase-cloud-messaging-push-scope")
            .then((registration) => {
              if (registration?.active) {
                console.log(
                  "Service worker is active:",
                  registration.active.state
                );
              } else {
                console.log("No active service worker found.");
              }
            })
            .catch((err) =>
              console.error("Error checking service worker:", err)
            );
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error setting up notifications:", error);
      }
    };

    setupNotifications();

    onMessage(messaging, (payload) => {
      console.log("Foreground message:", payload);
      if (payload.data) {
        const { title, description, orderID } = payload.data;
        alert(`${title}: ${description}\nOrder ID: ${orderID}`);
      }
    });
  }, []);

  return (
    <div className="App">
      {isMobileScreen ? (
        <BrowserRouterPage />
      ) : (
        <iframe 
          src={
            process.env.NODE_ENV === "production"
              ? "https://navyabakers.test4u.in/web"
              : "https://navyabaker.svpstaging.com/web/"
          }
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
            paddingBottom: "3rem",
          }}
        />
      )}
    </div>
  );
}

export default withAppWrapper(App);
